import http from '@/communication/AuthConnection'

export default async ({ commit }, { eventId }) => {
  try {
    const request = await http.get(`/v1/board/result/${eventId}`)
    return request.data
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/board/load-result/index.js